import EditDetails from "./EditDetails";
export default EditDetails;
